import * as S from "./styles.ts";

export interface IBasicCardProps extends Partial<HTMLDivElement> {
  children?: any;
  style?: any;
}

const BasicCard = ({ children, ...props }: IBasicCardProps) => {
  return (
    // @ts-ignore
    <S.Card {...props}>{children}</S.Card>
  );
};

export default BasicCard;
